var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlightDocumentsFullBrief(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3123 1.36515L10.9343 4L2.95873 2L1.96179 3L7.44497 7.5L4.95261 11H1.96179L0.964844 12L3.4572 13.5L4.45414 14.5L5.94955 17L6.9465 16V13L10.4358 10.5L14.922 16L15.919 15L13.9251 7L16.5546 2.6041C16.7671 2.24884 16.7112 1.79465 16.4189 1.50149C16.1253 1.20694 15.6686 1.15068 15.3123 1.36515Z",
    stroke: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightDocumentsFullBrief);
export default __webpack_public_path__ + "static/media/flight-documents-full-brief.f15e06f3538d562364a1a617a2c22b5b.svg";
export { ForwardRef as ReactComponent };